import { Box, Typography, Grid, Container } from "@material-ui/core";
import styled from "@emotion/styled";

import MainLayout from "@/layouts/MainLayout";
import ApplicationStartForm from "@/components/ApplicationStartForm";
import { useIsMedium } from "@/styles/breakpoints";

const Title = styled(Typography)`
  font-weight: 600;
  font-size: 28px;
  color: #000000;
`;

const BackgroundImage = styled.img`
  height: 600px;
  max-height: 40vh;
  bottom: 0;
  position: absolute;
  z-index: -1;
`;

export default function ApplicationSetup() {
  const isMedium = useIsMedium();
  return (
    <MainLayout
      backgroundImage={
        <BackgroundImage
          src="/images/application_setup_background_waves.png"
          alt="Application setup background waves"
        />
      }
      ctaOutlined
    >
      <Container>
        <Grid container spacing={10} alignItems="center">
          <Grid item xs={10} md={6}>
            <Box mb={4}>
              <Title variant="h3">Application Setup</Title>
            </Box>

            <Box mb={4}>
              <ApplicationStartForm />
            </Box>
          </Grid>

          {isMedium && (
            <Grid item md={6}>
              <img
                alt="Light bulb with gears"
                src="/images/lightbulb_with_gears.png"
                style={{
                  width: "100%",
                }}
              />
            </Grid>
          )}
        </Grid>
      </Container>
    </MainLayout>
  );
}
